import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'virtues-bootstrap';
import { mapIndex } from 'utilities/ramda';
import { Link } from 'react-router-dom';

import DataTable from 'components/ui/DataTable';
import PaperWithLoader from 'components/ui/PaperWithLoader';
import { ReactComponent as RedoDownload } from 'svg/redo-arrow.svg';
import { RESEARCHER } from 'constants/userRoles';
import CardiovascularInvestigationsRow from './CardiovascularInvestigationsRow';
import s from './styles.module.scss';

function CardiovascularInvestigations({
  t,
  loadData,
  userId,
  patientId,
  data: { error, data, loading },
  downloadDocumentReferencePdf,
  role,
}) {
  useEffect(() => {
    loadData({ userId, patientId });
  }, [loadData, patientId, userId]);

  const handleRedoDownload = () => loadData({ userId, patientId });

  return (
    <PaperWithLoader
      check={!!data.length}
      placeholder={t('reports.reportsNotFound')}
      error={error}
      loading={loading}
    >
      <DataTable>
        <thead>
          <tr>
            <td>{t('details')}</td>
            <td>{t('response')}</td>
          </tr>
        </thead>
        <tbody>
          {mapIndex(
            ({ total, id, lastUpdated }, index) => (
              <CardiovascularInvestigationsRow
                key={index}
                total={total}
                id={id}
                lastUpdated={lastUpdated}
                t={t}
                index={index}
                downloadDocumentReferencePdf={downloadDocumentReferencePdf}
                patientId={patientId}
              />
            ),
            data,
          )}
        </tbody>
      </DataTable>
      <div className={s.buttonWrapper}>
        {error ? (
          <Button icon={<RedoDownload />} onClick={handleRedoDownload}>
            {t('reports.viewAllReports')}
          </Button>
        ) : (
          <Button component={Link} to={`/patient/${patientId}/cardiovascular-reports`}>
            {role === RESEARCHER ? t('reports.viewAndManageReports') : t('reports.viewAllReports')}
          </Button>
        )}
      </div>
    </PaperWithLoader>
  );
}

CardiovascularInvestigations.propTypes = {
  t: PropTypes.func.isRequired,
  loadData: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    data: PropTypes.arrayOf(PropTypes.object),
    error: PropTypes.string,
  }).isRequired,
  downloadDocumentReferencePdf: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

export default CardiovascularInvestigations;
